module.exports = __webpack_public_path__ + "posture/static/img/backBone.eb09752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/bone/backBone.png
// module id = wyWN
// module chunks = 1